import { necessaryInfo } from "./NecessaryInfo";
import { utility } from "./Utility";
import thunk from "redux-thunk";
import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

const utilityTransform = createTransform(
  (inbound) => {
    if (!inbound) return inbound;
    const { showToast, showID, errorFound, ...rest } = inbound;
    return rest;
  },
  (outbound) => outbound,
  { whitelist: ['utility'] }
);

const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: ['necessaryInfo', 'utility'],
  version: 1,
  transforms: [utilityTransform],
};

const allReducers = combineReducers({
  necessaryInfo,
  utility,
});

const persistedReducer = persistReducer(persistConfig, allReducers);

const initialState = {};

const middleware = [thunk];
let con = compose(applyMiddleware(...middleware));
if (
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
  window.__REDUX_DEVTOOLS_EXTENSION__()
) {
  con = compose(
    applyMiddleware(...middleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  );
}

export const store = createStore(persistedReducer, initialState, con);
export const persistor = persistStore(store);
